module.exports = __webpack_public_path__ + "img/promo-vitara-2021-rascacielos.094db726.jpeg";